import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { delay, tap, of, Observable } from 'rxjs';
import { WithLoader } from '@elan/core/loader.decorator';
import { LoaderService } from '@elan/services/loader-service';
import { environment } from '@env/environment';
import { URLS, AUTH_URLS } from '@elan/core/constants/url/url-constants';
import { EncryptedStorageService } from '@elan/services/encrypted-storage.service';
import { ROLES } from '@elan/core/constants/role/role-constants';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public baseUrl = environment.apiUrl;
  public signInUser: any;
  constructor(private http: HttpClient, public loaderService: LoaderService, private encryptedStorageService: EncryptedStorageService) {

  }
  @WithLoader()
  login(loaderIds: Array<any> = [], values: any): Observable<any> {
    return this.http.post(`${this.baseUrl}${URLS[AUTH_URLS.LOGIN]}`, values);
  }
  setSignInUser(user: any) {
    this.signInUser = user;
  }

  getSignInUser() {
    if (this.signInUser) {
      return this.signInUser;
    }
    return this.encryptedStorageService.getItem('token');
  }

  isLoggedIn(): boolean {
    // Example: check token from localStorage
    this.setSignInUser(this.encryptedStorageService.getItem('token'));
    return !!this.signInUser;
  }

  isAdmin(): boolean {
    if (this.isLoggedIn()) {
      return this.signInUser?.data?.user?.user_roles?.filter((role: any) => role?.role?.name === ROLES.ADMIN).length > 0;
    }
    return false;
  }

}